<template>
  <v-row>
    <!-- Filtros -->
    <v-col cols="12">
      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loading"
          indeterminate
        />
      </div>

      <v-card class="pt-5">
        <v-card-title>Filtrar</v-card-title>

        <v-row class="px-2 ma-0">
          <!-- Select de campanha -->
          <v-col
            cols="12"
            sm="3"
          >
            <v-autocomplete
              v-model="filtroCampanhaId"
              :items="campanhas"
              item-text="nome"
              item-value="id"
              label="Campanha"
              outlined
              dense
              clearable
              hide-details
              placeholder="Todas as campanhas"
              @click="getCampanhas"
              @change="getRelatorio"
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.nome }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.statusNome }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- Select de status do log -->
          <v-col
            cols="12"
            sm="3"
          >
            <v-select
              v-model="filtroLogStatusIds"
              :items="logStatuses"
              item-text="nome"
              item-value="id"
              label="Status do envio"
              outlined
              dense
              clearable
              hide-details
              multiple
              small-chips
              @change="getRelatorio"
            />
          </v-col>

          <!-- Data início -->
          <v-col
            cols="12"
            md="2"
            sm="4"
          >
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dataInicioFormatada"
                  label="Período de:"
                  :disabled="!!filtroCampanhaId"
                  outlined
                  dense
                  clearable
                  hide-details
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @blur="filtroDataInicio = parseDate(dataInicioFormatada)"
                />
              </template>
              <v-date-picker
                v-model="filtroDataInicio"
                no-title
                color="primary"
                locale="pt-br"
                @input="menu1 = false"
                @change="getRelatorio"
              />
            </v-menu>
          </v-col>

          <!-- Data fim -->
          <v-col
            cols="12"
            md="2"
            sm="4"
          >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dataFimFormatada"
                  label="Período até:"
                  :disabled="!!filtroCampanhaId"
                  outlined
                  dense
                  clearable
                  hide-details
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @blur="filtroDataFim = parseDate(dataFimFormatada)"
                />
              </template>
              <v-date-picker
                v-model="filtroDataFim"
                no-title
                color="primary"
                locale="pt-br"
                @input="menu2 = false"
                @change="getRelatorio"
              />
            </v-menu>
          </v-col>

          <!-- Botões -->
          <v-col
            cols="12"
            sm="4"
            class="d-flex justify-start align-center"
          >
            <v-btn
              color="primary"
              :loading="loading"
              class="mx-3"
              @click="getRelatorio"
            >
              <span>Filtrar</span>
            </v-btn>

            <v-btn
              v-if="relatorioData.length"
              color="primary"
              outlined
              class="mx-3"
              @click="exportarExcel"
            >
              <v-icon left>
                {{ icons.mdiFileExcelOutline }}
              </v-icon>
              <span>Exportar</span>
            </v-btn>
          </v-col>
        </v-row>

        <!-- Cards de resumo totais -->
        <v-row
          v-if="relatorioData.length"
          class="px-4 pb-4 mt-2"
        >
          <v-col
            cols="6"
            sm="2"
          >
            <v-card
              outlined
              class="text-center pa-3"
            >
              <div class="text-h5 font-weight-bold">
                {{ totais.total }}
              </div>
              <div class="text-caption">
                Total
              </div>
            </v-card>
          </v-col>
          <v-col
            cols="6"
            sm="2"
          >
            <v-card
              outlined
              class="text-center pa-3"
            >
              <div class="text-h5 font-weight-bold primary--text">
                {{ totais.enviadas }}
              </div>
              <div class="text-caption">
                Enviadas
              </div>
            </v-card>
          </v-col>
          <v-col
            cols="6"
            sm="2"
          >
            <v-card
              outlined
              class="text-center pa-3"
            >
              <div class="text-h5 font-weight-bold success--text">
                {{ totais.entregues }}
              </div>
              <div class="text-caption">
                Entregues
              </div>
            </v-card>
          </v-col>
          <v-col
            cols="6"
            sm="2"
          >
            <v-card
              outlined
              class="text-center pa-3"
            >
              <div class="text-h5 font-weight-bold info--text">
                {{ totais.lidas }}
              </div>
              <div class="text-caption">
                Lidas
              </div>
            </v-card>
          </v-col>
          <v-col
            cols="6"
            sm="2"
          >
            <v-card
              outlined
              class="text-center pa-3"
            >
              <div class="text-h5 font-weight-bold error--text">
                {{ totais.falhas }}
              </div>
              <div class="text-caption">
                Falhas
              </div>
            </v-card>
          </v-col>
          <v-col
            cols="6"
            sm="2"
          >
            <v-card
              outlined
              class="text-center pa-3"
            >
              <div class="text-h5 font-weight-bold warning--text">
                {{ totais.bounces }}
              </div>
              <div class="text-caption">
                Bounces
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <!-- Sem dados -->
    <v-col
      v-if="arrayVazio"
      cols="12"
      class="text-subtitle-1 text-center mt-12"
    >
      Sem dados para gerar relatório
    </v-col>

    <!-- Cards das campanhas -->
    <v-col
      v-for="(item, index) in relatorioData"
      :key="index"
      cols="12"
      md="6"
      class="py-2"
    >
      <v-card elevation="3">
        <div class="py-4 px-4 d-flex justify-space-between align-center">
          <span class="text--primary font-weight-bold text-xl">{{ item.nome }}</span>
          <div class="d-flex align-center">
            <v-tooltip
              v-if="possivelmenteIncompleto(item)"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="warning"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ icons.mdiAlertCircleOutline }}
                </v-icon>
              </template>
              <span>Dados podem estar incompletos: nenhuma confirmação de entrega/leitura foi recebida do WhatsApp pra essa campanha.</span>
            </v-tooltip>

            <v-chip
              small
              outlined
              :color="getAgendamentoStatusColor(item.statusNome)"
              :class="`${getAgendamentoStatusColor(item.statusNome)}--text`"
              class="v-chip-light-bg font-weight-semibold"
            >
              {{ item.statusNome }}
            </v-chip>
          </div>
        </div>

        <v-divider />

        <v-card-text class="py-3 px-4">
          <div class="d-flex flex-wrap justify-space-between">
            <div class="mb-4 mb-sm-0">
              <span class="d-block">Canal: {{ item.canalNome }}</span>
              <span class="d-block">Data envio: {{ formatDate(item.dataHoraEnvio) }}</span>
              <span
                v-if="item.responsavelNome"
                class="d-block"
              >Responsável: {{ item.responsavelNome }}</span>
              <span
                v-if="item.descricao"
                class="d-block"
              >Descrição: {{ item.descricao }}</span>
            </div>

            <div class="d-flex align-center flex-wrap">
              <div class="text-center mx-3">
                <div class="text-h6 font-weight-bold">
                  {{ item.qtdTotal }}
                </div>
                <div class="text-caption">
                  Total
                </div>
              </div>
              <div class="text-center mx-3">
                <div class="text-h6 font-weight-bold primary--text">
                  {{ item.qtdEnviadas }}
                </div>
                <div class="text-caption">
                  Enviadas
                </div>
              </div>
              <div class="text-center mx-3">
                <div class="text-h6 font-weight-bold success--text">
                  {{ item.canalTipoId === CANAL_TIPO_EMAIL ? 'N/A' : item.qtdEntregues }}
                </div>
                <div class="text-caption">
                  Entregues
                </div>
              </div>
              <div class="text-center mx-3">
                <div class="text-h6 font-weight-bold info--text">
                  {{ item.canalTipoId === CANAL_TIPO_EMAIL ? 'N/A' : item.qtdLidas }}
                </div>
                <div class="text-caption">
                  Lidas
                </div>
              </div>
              <div class="text-center mx-3">
                <div class="text-h6 font-weight-bold error--text">
                  {{ item.qtdFalhas }}
                </div>
                <div class="text-caption">
                  Falhas
                </div>
              </div>
              <div class="text-center mx-3">
                <div class="text-h6 font-weight-bold warning--text">
                  {{ item.qtdBounces || 0 }}
                </div>
                <div class="text-caption">
                  Bounces
                </div>
              </div>
            </div>
          </div>
        </v-card-text>

        <div class="px-4 pb-3 d-flex justify-end">
          <v-btn
            small
            outlined
            color="primary"
            @click="abrirDetalhes(item)"
          >
            Ver detalhes
          </v-btn>
        </div>
      </v-card>
    </v-col>

    <!-- Dialog de detalhes -->
    <custom-dialog
      :is-dialog-open="isDetalhesDialogOpen"
      :close-dialog="fecharDetalhes"
      :dialog-title="agendamentoSelecionado ? `Detalhes — ${agendamentoSelecionado.nome}` : 'Detalhes'"
    >
      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loadingDetalhes"
          indeterminate
        />
      </div>

      <div
        v-if="!loadingDetalhes && !detalhes.length"
        class="text-center py-6 text--secondary"
      >
        Nenhum detalhe encontrado.
      </div>

      <v-simple-table
        v-else
        dense
      >
        <thead>
          <tr>
            <th>Nome</th>
            <th>E-mail</th>
            <th>Celular</th>
            <th>Empresa</th>
            <th>Status</th>
            <th>Data</th>
            <th>Motivo</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, i) in detalhes"
            :key="i"
          >
            <td>{{ item.nome || '—' }}</td>
            <td>{{ item.email || '—' }}</td>
            <td>{{ item.celular || '—' }}</td>
            <td>{{ item.empresa || '—' }}</td>
            <td>
              <v-chip
                x-small
                outlined
                :color="getLogStatusColor(item.logStatusNome)"
                :class="`${getLogStatusColor(item.logStatusNome)}--text`"
                class="v-chip-light-bg font-weight-semibold"
              >
                {{ item.logStatusNome }}
              </v-chip>
            </td>
            <td>{{ formatDateHour(item.date) }}</td>
            <td>{{ item.message || '—' }}</td>
          </tr>
        </tbody>
      </v-simple-table>

      <div class="d-flex justify-end mt-4">
        <v-btn
          outlined
          color="success"
          small
          :disabled="!detalhes.length"
          @click="exportarExcelDetalhes"
        >
          <v-icon left>
            {{ icons.mdiFileExcelOutline }}
          </v-icon>
          Exportar detalhes
        </v-btn>
      </div>
    </custom-dialog>
  </v-row>
</template>

<script>
import Vue from 'vue'
import * as XLSX from 'xlsx'
import { ref, computed, onMounted } from '@vue/composition-api'
import { mdiMagnify, mdiFileExcelOutline, mdiAlertCircleOutline } from '@mdi/js'
import { getDataInicialMes, getDataFinalMes } from '@/utils/dateTime'
import CustomDialog from '@/components/dialog/Dialog.vue'
import RelatorioService from '@/services/modules/RelatorioService'
import AgendamentoMensagensService from '@/services/modules/AgendamentoMensagensService'
import { useStatusColor } from '@/composables/useStatusColor'
import { useRouter } from '@/@core/utils'

export default {
  components: { CustomDialog },

  setup() {
    const loading = ref(false)
    const loadingDetalhes = ref(false)
    const arrayVazio = ref(false)
    const relatorioData = ref([])
    const detalhes = ref([])

    const { getAgendamentoStatusColor, getLogStatusColor } = useStatusColor()
    const { route } = useRouter()

    // ─── Filtros ──────────────────────────────────────────────────────────────

    const campanhas = ref([])
    const filtroCampanhaId = ref(null)
    const filtroNome = ref('')
    const filtroLogStatusIds = ref([])
    const filtroDataInicio = ref(getDataInicialMes())
    const filtroDataFim = ref(getDataFinalMes())
    const menu1 = ref(false)
    const menu2 = ref(false)

    const logStatuses = [
      { id: 1, nome: 'Rejeitada' },
      { id: 2, nome: 'Enviada' },
      { id: 3, nome: 'Entregue' },
      { id: 4, nome: 'Não entregue (Bounce)' },
      { id: 5, nome: 'Lida' },
      { id: 6, nome: 'Apagada' },
      { id: 7, nome: 'Clicada' },
      { id: 8, nome: 'Verificada' },
    ]

    const isDetalhesDialogOpen = ref(false)
    const agendamentoSelecionado = ref(null)

    // ─── Formatação ───────────────────────────────────────────────────────────

    const formatDate = dateStr => {
      if (!dateStr) return '—'
      const date = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }

    const formatDateHour = dateStr => {
      if (!dateStr) return '—'
      const [datePart, timePart] = dateStr.includes('T') ? dateStr.split('T') : [dateStr, '']
      const [year, month, day] = datePart.split('-')
      const time = timePart ? timePart.substring(0, 5) : ''
      return time ? `${day}/${month}/${year} ${time}` : `${day}/${month}/${year}`
    }

    const parseDate = date => {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    const dataInicioFormatada = computed(() => formatDate(filtroDataInicio.value))
    const dataFimFormatada = computed(() => formatDate(filtroDataFim.value))

    // ─── Alerta de dado possivelmente incompleto ─────────────────────────────
    // A confirmação de Entregue/Lida do WhatsApp depende de webhook da Zenvia. Campanhas de
    // antes dessa integração estar configurada ficam presas em "Enviada" pra sempre (a Zenvia
    // não reenvia status retroativamente), sem forma de saber isso só pelos números do card.
    // Heurística: canal WhatsApp, campanha com mais de 24h, 100% dos envios ainda em "Enviada" e
    // zero movimento em Entregue/Lida/Falha/Bounce.
    const CANAL_TIPO_EMAIL = 1
    const CANAL_TIPO_WHATSAPP = 4
    const HORAS_MINIMAS_PARA_CONSIDERAR_TRAVADA = 24

    function possivelmenteIncompleto(item) {
      if (item.canalTipoId !== CANAL_TIPO_WHATSAPP) return false
      if (!item.qtdTotal) return false
      if (item.qtdEnviadas !== item.qtdTotal) return false
      if ((item.qtdEntregues || 0) + (item.qtdLidas || 0) + (item.qtdFalhas || 0) + (item.qtdBounces || 0) !== 0) return false

      if (!item.dataHoraEnvio) return false
      const horasDesdeOEnvio = (Date.now() - new Date(item.dataHoraEnvio).getTime()) / (1000 * 60 * 60)

      return horasDesdeOEnvio >= HORAS_MINIMAS_PARA_CONSIDERAR_TRAVADA
    }

    // ─── Totais ───────────────────────────────────────────────────────────────

    const totais = computed(() => ({
      total: relatorioData.value.reduce((acc, it) => acc + (it.qtdTotal || 0), 0),
      enviadas: relatorioData.value.reduce((acc, it) => acc + (it.qtdEnviadas || 0), 0),
      entregues: relatorioData.value.reduce((acc, it) => acc + (it.qtdEntregues || 0), 0),
      lidas: relatorioData.value.reduce((acc, it) => acc + (it.qtdLidas || 0), 0),
      falhas: relatorioData.value.reduce((acc, it) => acc + (it.qtdFalhas || 0), 0),
      bounces: relatorioData.value.reduce((acc, it) => acc + (it.qtdBounces || 0), 0),
    }))

    // ─── Campanhas ────────────────────────────────────────────────────────────

    async function getCampanhas() {
      if (campanhas.value.length) return
      campanhas.value = await AgendamentoMensagensService.get()
    }

    // ─── Busca ────────────────────────────────────────────────────────────────

    async function getRelatorio() {
      if (loading.value) return

      if (filtroDataInicio.value && filtroDataFim.value) {
        if (Date.parse(filtroDataFim.value) < Date.parse(filtroDataInicio.value)) {
          Vue.$toast.warning('O período final deve ser maior que o período inicial!')
          return
        }
      }

      try {
        loading.value = true
        arrayVazio.value = false

        relatorioData.value = await RelatorioService.getRelatorioEnvioMassa({
          agendamentoId: filtroCampanhaId.value || null,
          logStatusIds: filtroLogStatusIds.value.length ? filtroLogStatusIds.value : null,
          nomeOuDescricao: filtroNome.value || null,
          dataInicio: filtroDataInicio.value || null,
          dataFim: filtroDataFim.value || null,
        })

        arrayVazio.value = relatorioData.value.length === 0
      } catch {
        arrayVazio.value = true
      } finally {
        loading.value = false
      }
    }

    // ─── Detalhes ─────────────────────────────────────────────────────────────

    async function abrirDetalhes(agendamento) {
      agendamentoSelecionado.value = agendamento
      isDetalhesDialogOpen.value = true
      detalhes.value = []

      try {
        loadingDetalhes.value = true
        detalhes.value = await RelatorioService.getRelatorioEnvioMassaDetalhes(agendamento.id, filtroLogStatusIds.value)
      } finally {
        loadingDetalhes.value = false
      }
    }

    function fecharDetalhes() {
      isDetalhesDialogOpen.value = false
      agendamentoSelecionado.value = null
      detalhes.value = []
    }

    // ─── Exportar Excel (campanhas) ───────────────────────────────────────────

    function exportarExcel() {
      const rows = relatorioData.value.map(it => ({
        Campanha: it.nome,
        Descrição: it.descricao || '',
        Canal: it.canalNome,
        'Data Envio': formatDate(it.dataHoraEnvio),
        Responsável: it.responsavelNome || '',
        Status: it.statusNome,
        Total: it.qtdTotal,
        Enviadas: it.qtdEnviadas,
        Entregues: it.canalTipoId === CANAL_TIPO_EMAIL ? 'N/A' : it.qtdEntregues,
        Lidas: it.canalTipoId === CANAL_TIPO_EMAIL ? 'N/A' : it.qtdLidas,
        Falhas: it.qtdFalhas,
        Bounces: it.qtdBounces || 0,
      }))

      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Relatório')
      XLSX.writeFile(wb, `relatorio-envio-massa-${new Date().toISOString().split('T')[0]}.xlsx`)
    }

    // ─── Exportar Excel (detalhes) ────────────────────────────────────────────

    function exportarExcelDetalhes() {
      const rows = detalhes.value.map(it => ({
        Nome: it.nome || '',
        'E-mail': it.email || '',
        Celular: it.celular || '',
        Empresa: it.empresa || '',
        Status: it.logStatusNome,
        Data: formatDateHour(it.date),
        Motivo: it.message || '',
      }))

      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Detalhes')
      XLSX.writeFile(wb, `detalhes-${agendamentoSelecionado.value?.nome ?? 'campanha'}-${new Date().toISOString().split('T')[0]}.xlsx`)
    }

    onMounted(async () => {
      const agendamentoIdParam = route.value?.query?.agendamentoId
      if (agendamentoIdParam) {
        filtroCampanhaId.value = Number(agendamentoIdParam)
        filtroDataInicio.value = null
        filtroDataFim.value = null
      }
      await getRelatorio()
    })

    return {
      loading,
      loadingDetalhes,
      arrayVazio,
      relatorioData,
      detalhes,
      campanhas,
      filtroCampanhaId,
      filtroNome,
      filtroLogStatusIds,
      logStatuses,
      filtroDataInicio,
      filtroDataFim,
      dataInicioFormatada,
      dataFimFormatada,
      menu1,
      menu2,
      totais,
      isDetalhesDialogOpen,
      agendamentoSelecionado,
      getCampanhas,
      getRelatorio,
      abrirDetalhes,
      fecharDetalhes,
      exportarExcel,
      exportarExcelDetalhes,
      getAgendamentoStatusColor,
      getLogStatusColor,
      formatDate,
      formatDateHour,
      parseDate,
      possivelmenteIncompleto,
      CANAL_TIPO_EMAIL,
      icons: { mdiMagnify, mdiFileExcelOutline, mdiAlertCircleOutline },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
